// Imports
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "body {\n  background: #222629;\n}\n", "",{"version":3,"sources":["index.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB","file":"index.css","sourcesContent":["body {\n  background: #222629;\n}\n"]}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
